import React, { useState, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import dayjs from "dayjs";
import CustomCheckbox from "../FormFields/Custom/CustomCheckbox";
import { invoiceFrequencyTypeOptions } from "../../assets/data/projectData";

const InvoiceSidebar = ({ data = [], selectedValues, handleSelectTimeDate }) => {
  const [openIndexes, setOpenIndexes] = useState([]);
  const [openSubIndexes, setOpenSubIndexes] = useState({});

  const handleToggle = (idx) => {
    setOpenIndexes((prev) =>
      prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]
    );
  };

  const handleSubToggle = (parentIdx, childIdx) => {
    setOpenSubIndexes((prev) => {
      const key = `${parentIdx}-${childIdx}`;
      return {
        ...prev,
        [key]: !prev[key],
      };
    });
  };

  // Process data to create one checkbox per range instead of splitting by dates
  const processedData = useMemo(() => {
    return data.map((item, index) => {
      // Create checkbox options - one per range, not split by dates
      const datesCombine = item.ranges.map((range, rangeIdx) => {
        // Format the date range for display
        // const fromDate = dayjs(range.from).format('MMM DD, YYYY');
        // const toDate = dayjs(range.to).format('MMM DD, YYYY');
        const fromDate = dayjs(range.from).utc().format('MMM DD, YYYY');
        const toDate = dayjs(range.to).utc().format('MMM DD, YYYY');

        // const fromDate = dateFormator(range.from);
        // const toDate = dateFormator(range.to);
        const rangeLabel = `${fromDate} - ${toDate}`;
        
        return {
          label: rangeLabel,
          value: `${item.uiid}-${rangeIdx}-${range.from}-${range.to}`,
          rangeData: range,
          uiid: item.uiid,
        };
      });

      // Convert selectedValues objects to checkbox-compatible format
      const selectedCheckboxValues = selectedValues && Array.isArray(selectedValues)
        ? selectedValues
            .map(selectedObj => {
              // Find matching option in datesCombine
              return datesCombine.find(option => {
                const rangeMatches = (
                  option.rangeData.from === selectedObj.from &&
                  option.rangeData.to === selectedObj.to &&
                  option.rangeData.type === selectedObj.type &&
                  option.rangeData.uiid === selectedObj.uiid
                );
                
                return rangeMatches;
              });
            })
            .filter(Boolean)
            .map(option => option.value)
        : [];

      return {
        ...item,
        datesCombine,
        selectedCheckboxValues,
        index
      };
    });
  }, [data, selectedValues]);


  return (
    <div className="w-full border-2 rounded-lg overflow-hidden flex flex-col gap-3">
      <div className="bg-neutrals-500 text-white p-2 text-center rounded-b-lg">
        {data[0]?.empName || ''}
      </div>
      <div>
        {processedData.map((item) => {
          const isOpen = openIndexes.includes(item.index);
          

          return (
            <div key={item.index}>
              <div
                className="collapsible flex justify-between items-center cursor-pointer bg-slate-100 p-2"
                onClick={() => handleToggle(item.index)}
              >
                <div className="flex items-center gap-1">
                  <span className="material-symbols-rounded leading-none">
                    {!isOpen ? "expand_more" : "expand_less"}
                  </span>
                  <div>
                    {invoiceFrequencyTypeOptions?.find(data => data.value === item?.type)?.label}
                  </div>
                </div>
                <div className="text-xs text-white bg-black rounded-full flex justify-center items-center leading-none w-6 h-6">
                  {item.ranges.length}
                </div>
              </div>
              <AnimatePresence initial={false}>
                {!isOpen && (
                  <motion.div
                    className="collapsible-content my-2"
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="px-2 py-1 flex flex-col gap-2">
                      <div>
                        <div className="flex-1 flex justify-between items-center ml-2 cursor-pointer">
                          <div className="flex items-center gap-2">
                            <div>{item.companyName || ''}</div>
                          </div>
                        </div>
                        <AnimatePresence initial={false}>
                          <motion.div
                            className="text-sm text-gray-500 p-3"
                            initial={{ opacity: 0, height: 0 }}
                            animate={{ opacity: 1, height: "auto" }}
                            exit={{ opacity: 0, height: 0 }}
                            transition={{ duration: 0.3 }}
                          >
                            <div className="flex flex-col gap-2">
                              <CustomCheckbox
                                list
                                color="warning"
                                options={item.datesCombine}
                                selectedValues={item.selectedCheckboxValues}
                                onChange={(selectedCheckboxValues) => {
                                  // Convert back to the format expected by handleSelectTimeDate
                                  const selectedObjects = selectedCheckboxValues.map(value => {
                                    const option = item.datesCombine.find(opt => opt.value === value);
                                    return option.rangeData;
                                  });
                                  
                                  handleSelectTimeDate(selectedObjects);
                                }}
                                multiple
                              />
                            </div>
                          </motion.div>
                        </AnimatePresence>
                      </div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InvoiceSidebar;